import React from "react";
import { useLabelsAndHelpText } from "../../helpers/useLabelsAndHelpText";
import OriginalFormTextInput from "./FormTextInput";
import OriginalFormSelect from "./FormSelect";
import OriginalFormCheckboxGroup, {
  FormCheckbox as OriginalFormCheckbox
} from "./FormCheckboxGroup";
import OriginalFormTextarea from "./FormTextarea";
import OriginalFormDatePicker from "./FormDatePicker";
import OriginalFormRadioGroup from "./FormRadioGroup";
import OriginalFormFileUpload from "./FormFileUpload";

/**
 * Higher-order component that enhances form components with automatic label and help text
 */
export const withAutoLabels = (Component) => {
  return ({ section, form, name, label, helpText, labelHelp, ...props }) => {
    const getFieldData = useLabelsAndHelpText(section, form);
    const fieldData = getFieldData(name);
    // Use JSON data as defaults, allow props to override
    const enhancedProps = {
      ...props,
      name,
      label: label || fieldData.label,
      helpText: helpText || fieldData.helpText,
      labelHelp: labelHelp || fieldData.labelHelp
    };

    return <Component {...enhancedProps} />;
  };
};

// Enhanced form components - require section and form props
export const FormTextInput = withAutoLabels(OriginalFormTextInput);
export const FormSelect = withAutoLabels(OriginalFormSelect);
export const FormCheckboxGroup = withAutoLabels(OriginalFormCheckboxGroup);
export const FormCheckbox = withAutoLabels(OriginalFormCheckbox);
export const FormTextarea = withAutoLabels(OriginalFormTextarea);
export const FormDatePicker = withAutoLabels(OriginalFormDatePicker);
export const FormRadioGroup = withAutoLabels(OriginalFormRadioGroup);
export const FormFileUpload = withAutoLabels(OriginalFormFileUpload);

